import React from "react";
import Nav from "./Nav";
import ContactForm from "./ContactForm";

function ContactMe() {
  return (
    <div>
      <Nav />
      <ContactForm />
    </div>
  );
}

export default ContactMe;
